<template>
<div id="accountManage"></div>
</template>

<script>
export default {
  name: 'accountManage'
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/roleAndPermission/accountManage/index.vue